import { Fragment } from 'react';

const amenityIcons = {
  'privateCarTransfer': {
    className: 'icon-private-transfers',
    popover: 'popoverPrivateCarTransfer',
    featureName: 'Private Car Transfer',
    description: (
      <Fragment>
        This category also includes the exclusive indulgence of private
        transfers to and from the airport in chauffeur-driven luxury private car.
      </Fragment>
    ),
  },
  'roomService': {
    className: 'icon-room-service',
    popover: 'popoverRoomService',
    featureName: 'Room Service',
    description: (
      <Fragment>
        Whether it is a simple continental breakfast delivered to your
        room or a more elaborate dinner affair, room service is another
        ultra all inclusive exclusive.
      </Fragment>
    ),
  },
  'Soaking Tubs': {
    className: 'ic-soaking-tub',
    popover: 'popoverTubs',
    featureName: 'Soaking Tubs',
    description: (
      <Fragment>
        A whole new way to celebrate romance al fresco.
      </Fragment>
    ),
    learnMore: '/all-inclusive/soaking-tubs/',
  },
  'handicapFriendly': {
    className: 'ic-wheelchair',
    popover: 'popoverHandicapFriendly',
    featureName: 'Handicap Friendly',
    description: (
      <Fragment>
        This room is wheelchair accessible and features special amenities.
        For more information, please review our <a href="/accessibility-guide/">
        Accessibility Guide</a>
      </Fragment>
    ),
  },
  'loveNest': {
    className: 'icon-together-nest-no-txt',
    popover: 'popoverLoveNest',
    featureName: (
      <Fragment>
        Together Nest Suites<sup>&reg;</sup>
      </Fragment>
    ),
    description: (
      <Fragment>
        Defined by exclusive amenities and unique designs for heavenly
        seclusion, these <a href="/all-inclusive/accommodations/together-nest/">romantic luxury
        suites and villas</a> create the ultimate escape for love birds.
      </Fragment>
    ),
  },
  'butler': {
    className: 'icon-butler',
    popover: 'popoverButlerService',
    featureName: 'Butler Service',
    description: (
      <Fragment>
        This suite features the intuitive services of your very
        own <a href="/all-inclusive/butler-service/">personal butler</a> who
        will pamper you in extraordinary ways throughout your stay.
      </Fragment>
    ),
  },
  'Free Wifi': {
    className: 'icon-wi-fi',
    popover: 'popoverWiFi',
    featureName: 'Free Wifi',
    description: (
      <Fragment>
        Free Wi-Fi is included.
      </Fragment>
    ),
  },
  'rollsRoyceTransfer': {
    className: 'ic-rolls-royce',
    popover: 'popoverRollsRoyceTransfer',
    featureName: 'Rolls Royce Transfer',
    description: (
      <Fragment>
        This category also includes the exclusive indulgence of private transfers
        to and from the airport in chauffeur-driven Rolls Royce or Mercedes Benz.
      </Fragment>
    ),
  },
  'concierge': {
    className: 'icon-concierge',
    popover: 'popoverConciergeService',
    featureName: 'Concierge Service',
    description: (
      <Fragment>
        This room category includes access to the exclusive amenities &amp;
        extra pampering of <a href="/all-inclusive/concierge-service/">Suite Concierge service</a>,
        featuring such additional perks as a private check-in, dedicated lounge,
        stocked in-room bars &amp; much more!
      </Fragment>
    ),
  },
  'choicePremiumSpirits': {
    className: 'icon-choice-premium-spirits',
    popover: 'popoverChoicePremiumSpirits',
    featureName: 'In-Room Bar w/ Premium Spirits',
    description: (
      <Fragment>
        This suite features a fully stocked bar with juices, sodas, water, beer, and your selection of premium spirits and Robert Mondavi Twin Oaks<sup>&reg;</sup> wine that is restocked daily. Alcoholic beverages are available upon request.
      </Fragment>
    ),
  },
  'premiumSpirits': {
    className: 'icon-premium-spirits',
    popover: 'popoverPremiumSpirits',
    featureName: 'In-Room Bar w/ Select Spirits',
    description: (
      <Fragment>
        This suite features a fully stocked bar with juices, sodas, water, beer, premium spirits, and Robert Mondavi Twin Oaks<sup>&reg;</sup>  wine that is restocked daily. Alcoholic beverages are available upon request.
      </Fragment>
    ),
  },
  'beerWine': {
    className: 'icon-beer-wine',
    popover: 'popoverBeerWine',
    featureName: 'In-Room Local Beer & Wine',
    description: (
      <Fragment>
        This room includes juice, soda, water, Robert Mondavi Twin Oaks<sup>&reg;</sup> wine and local beer
        replenished daily.
      </Fragment>
    ),
  },
  'airportTransfers': {
    className: 'ic-transfers',
    popover: 'popoverAirportTransfers',
    featureName: 'Airport Transfers',
    description: (
      <Fragment>
        Relax and enjoy your stress-free ride with non-stop resort transfers to and
        from the airport, featuring air-conditioning and comfortable, spacious seating.
      </Fragment>
    ),
  },
  'washer': {
    className: 'icon-washer-dryer',
    popover: 'popoverWasher',
    featureName: (
      <Fragment>In-Room Washer &amp; Dryer</Fragment>
    ),
    description: (
      <Fragment>
        This room category includes a washer &amp; dryer inside the room. Take care of all your laundry needs without leaving the comfort of your suite with your in-room washer &amp; dryer.
      </Fragment>
    ),
  },
  'vipArrivalService': {
    className: 'icon-vip',
    popover: 'popoverVipArrivalService',
    featureName: 'VIP Arrival',
    description: (
      <Fragment>
        This category also includes VIP arrival service including expedited immigration, personal airport greeting, private
        luxury transfer and access to arrival lounge amenities.
      </Fragment>
    )
  },
};


export default amenityIcons;
